/* bluamor V2.1 additions (Oct 17): free-shipping bar, bundle nudge, cart add-on picks, one-tap add to bag, EcoCart styling, scent finder, ingredient filter. */
(function () {
  var cfg = window.blConfig || { freeShippingCents: 3500 };

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Cart helpers: free-shipping bar, bundle nudge, cart add-on picks ---------- */
  var ROOT = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }

  function shipBar() {
    var el = document.createElement('div');
    el.className = 'bl-ship';
    el.hidden = true;
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<p class="bl-ship__msg"></p><div class="bl-ship__track" aria-hidden="true"><span></span></div><p class="bl-ship__tier" hidden></p>';
    return el;
  }

  function boostPanel() {
    var el = document.createElement('section');
    el.className = 'bl-boost';
    el.hidden = true;
    el.setAttribute('aria-label', 'Recommended add-ons');
    el.innerHTML = '<div class="bl-boost__head"><p class="bl-boost__title"></p><p class="bl-boost__sub"></p></div><div class="bl-boost__list"></div>';
    return el;
  }

  /* Dawn re-renders cart sections after every change, so (re)insert our pieces whenever they go missing. */
  function placeBars() {
    var spots = [];
    var notifHeader = document.querySelector('#cart-notification .cart-notification__header');
    if (notifHeader) spots.push(notifHeader);
    var cartTitle = document.querySelector('cart-items .title-wrapper-with-link');
    if (cartTitle) spots.push(cartTitle);
    spots.forEach(function (s) {
      var next = s.nextElementSibling;
      if (!next || !next.classList.contains('bl-ship')) s.insertAdjacentElement('afterend', shipBar());
    });
    var form = document.querySelector('cart-items form#cart');
    if (form && cfg.picks && !document.querySelector('cart-items .bl-boost')) form.insertAdjacentElement('afterend', boostPanel());
  }

  function tierInfo(cart) {
    var b = cfg.bundle;
    if (!b) return null;
    var n = 0;
    cart.items.forEach(function (i) { if (b.ids.indexOf(i.variant_id) > -1) n += i.quantity; });
    var cur = 0, next = null;
    b.tiers.forEach(function (tr) { if (n >= tr[0]) cur = tr[1]; else if (!next) next = tr; });
    return { n: n, cur: cur, next: next, need: next ? next[0] - n : 0, url: b.url };
  }

  function renderBoost(panel, cart, left, t) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.variant_id] = 1; });
    var picks = (cfg.picks || []).filter(function (p) { return !inCart[p.v]; }).sort(function (a, b) { return a.p - b.p; }).slice(0, 4);
    var title = '', sub = '';
    if (cart.item_count && picks.length) {
      var cheap = picks[0].p;
      if (t && t.need === 1) {
        title = 'Add 1 more item and save ' + t.next[1] + '% on your bundle';
        sub = 'Any deodorant, lip balm or lotion bar counts' + (left > 0 && cheap * (1 - t.next[1] / 100) >= left ? ', and it unlocks free shipping too.' : '.') + ' The discount is applied automatically at checkout.';
      } else if (left > 0) {
        title = 'You’re ' + money(left, cart.currency) + ' away from free shipping';
        sub = 'Add a little something and ship for free.' + (t && t.need === 2 ? ' Add 2 and you’ll also save ' + t.next[1] + '% with bundle pricing.' : '');
      } else if (t && t.need === 2) {
        title = 'Add 2 more items and save ' + t.next[1] + '%';
        sub = 'Mix any deodorants, lip balms and lotion bars. The discount is applied automatically at checkout.';
      }
    }
    panel.hidden = !title;
    if (!title) return;
    panel.querySelector('.bl-boost__title').textContent = title;
    panel.querySelector('.bl-boost__sub').textContent = sub;
    panel.querySelector('.bl-boost__list').innerHTML = picks.map(function (p) {
      return '<div class="bl-boost__item">' +
        '<a class="bl-boost__img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
        '<div class="bl-boost__info"><a class="bl-boost__name" href="' + esc(p.u) + '">' + esc(p.t) + '</a>' +
        '<span class="bl-boost__price">' + money(p.p, cart.currency) + (p.c > p.p ? ' <s>' + money(p.c, cart.currency) + '</s>' : '') + '</span></div>' +
        '<button type="button" class="bl-boost__add" data-boost-add="' + p.v + '" aria-label="Add ' + esc(p.t) + ' to bag">Add</button></div>';
    }).join('');
  }

  var shipTimer;
  function updateShip() {
    clearTimeout(shipTimer);
    shipTimer = setTimeout(function () {
      placeBars();
      var bars = document.querySelectorAll('.bl-ship');
      var panels = document.querySelectorAll('.bl-boost');
      if (!bars.length && !panels.length) return;
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          placeBars();
          var rate = window.Shopify && Shopify.currency && Shopify.currency.rate ? parseFloat(Shopify.currency.rate) : 1;
          var goal = Math.round(cfg.freeShippingCents * (rate || 1));
          var total = cart.total_price;
          var left = goal - total;
          var pct = Math.max(0, Math.min(100, (total / goal) * 100));
          var t = tierInfo(cart);
          var tierMsg = '';
          if (t) {
            var link = '<a href="' + t.url + '">Build your own bundle</a>';
            if (t.n > 0 && !t.cur) tierMsg = 'Add ' + t.need + ' more deodorant, lip balm or lotion bar to save ' + t.next[1] + '%. ' + link;
            else if (t.cur && t.next) tierMsg = 'Bundle savings unlocked: ' + t.cur + '% off! Add ' + t.need + ' more to save ' + t.next[1] + '%. ' + link;
            else if (t.cur) tierMsg = 'You’re getting our best bundle price: ' + t.cur + '% off your deodorants, lip balms and lotion bars.';
          }
          document.querySelectorAll('.bl-ship').forEach(function (b) {
            b.hidden = cart.item_count === 0;
            b.classList.toggle('is-done', left <= 0);
            b.querySelector('.bl-ship__msg').innerHTML = left > 0
              ? 'You’re <strong>' + money(left, cart.currency) + '</strong> away from free shipping.'
              : 'You’ve unlocked <strong>free shipping</strong>!';
            b.querySelector('.bl-ship__track span').style.width = pct + '%';
            var tp = b.querySelector('.bl-ship__tier');
            if (tp) { tp.hidden = !tierMsg; tp.innerHTML = tierMsg; }
          });
          document.querySelectorAll('.bl-boost').forEach(function (p) { renderBoost(p, cart, left, t); });
        })
        .catch(function () {});
    }, 250);
  }

  /* Refresh after ANY cart change: Dawn quantity/remove, quick add, our buttons, apps (EcoCart etc). */
  function watchCartRequests() {
    var re = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
    if (window.fetch && !window.fetch.__bl) {
      var of = window.fetch;
      var wrapped = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var pr = of.apply(this, arguments);
        if (re.test(url.split('#')[0])) pr.then(function () { updateShip(); }, function () {});
        return pr;
      };
      wrapped.__bl = true;
      window.fetch = wrapped;
    }
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (re.test(String(url))) this.addEventListener('loadend', function () { updateShip(); });
      return oo.apply(this, arguments);
    };
  }

  /* Add from the cart add-on panel, then re-render Dawn's cart sections in place. */
  function boostAdd(btn) {
    var cartItems = document.querySelector('cart-items');
    var secs = cartItems && cartItems.getSectionsToRender ? cartItems.getSectionsToRender() : [];
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-boost-add'), 10), quantity: 1 }], sections: secs.map(function (s) { return s.section; }), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'Error');
        if (!res.sections) { window.location.reload(); return; }
        secs.forEach(function (s) {
          var html = res.sections[s.section];
          if (!html) return;
          var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
          var target = document.getElementById(s.id);
          target = target && (target.querySelector(s.selector) || target);
          if (src && target) target.innerHTML = src.innerHTML;
        });
        document.querySelectorAll('cart-items, #main-cart-footer').forEach(function (el) { el.classList.remove('is-empty'); });
        updateShip();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
  }

  /* ---------- EcoCart widget: on-brand colors, readable in dark mode ---------- */
  var ECO_CSS = [
    '.eco-wrapper > .border { border: 2px solid var(--bl-eco-border, #00b0e8) !important; border-radius: 16px !important; background: var(--bl-eco-bg, #eef9fd) !important; padding: 1.2rem 1.4rem !important; }',
    '.eco-wrapper > .border, .eco-wrapper > .border * { color: var(--bl-eco-text, #0b4f68) !important; font-family: inherit !important; }',
    '.eco-wrapper .font-semibold, .eco-wrapper .font-semibold * { font-weight: 700 !important; }',
    '.eco-wrapper .font-bold { color: var(--bl-eco-accent, #007aa3) !important; }',
    '.eco-wrapper .text-gray-600, .eco-wrapper .text-gray-600 *, .eco-wrapper button { color: var(--bl-eco-muted, #3b6676) !important; }',
    '.eco-wrapper label svg rect { fill: var(--bl-eco-check, #00b0e8) !important; }',
    '.eco-wrapper img { filter: var(--bl-eco-logo, none); }'
  ].join('\n');
  function styleEco() {
    document.querySelectorAll('eco-widget, eco-cart').forEach(function (w) {
      var r = w.shadowRoot;
      if (!r || r.querySelector('style[data-bl-eco]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-bl-eco', '');
      st.textContent = ECO_CSS;
      r.appendChild(st);
    });
  }
  function watchEco() {
    styleEco();
    var n = 0, iv = setInterval(function () { styleEco(); if (++n > 20) clearInterval(iv); }, 500);
    new MutationObserver(function () { styleEco(); }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- One-tap add to bag (cards) ---------- */
  function addToBag(btn) {
    var id = btn.getAttribute('data-bl-add');
    var label = btn.textContent;
    var notif = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { id: id, quantity: 1 };
    if (notif && notif.getSectionsToRender) {
      body.sections = notif.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'Error');
        btn.textContent = 'Added ✓';
        if (notif && notif.renderContents && res.sections) {
          notif.renderContents(res);
        } else {
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bl-card', cartData: res }); } catch (e) {}
        }
        updateShip();
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2500);
      })
      .catch(function (err) {
        btn.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = label; }, 2500);
      })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }

  /* ---------- Scent finder ---------- */
  var BUNDLES = { deo: 'deo-bundle', lips: 'lips-bundle', body: 'body-bundle', none: 'unscented-bundle' };

  function initQuiz(q) {
    var state = {};
    var history = [];
    var steps = Array.prototype.slice.call(q.querySelectorAll('[data-step]'));
    var bar = q.querySelector('.bl-quiz__bar span');
    var count = q.querySelector('.bl-quiz__count');
    var back = q.querySelector('[data-quiz-back]');

    function show(name, push) {
      if (push !== false && q.dataset.current) history.push(q.dataset.current);
      q.dataset.current = name;
      steps.forEach(function (s) { s.hidden = s.dataset.step !== name; });
      var step = q.querySelector('[data-step="' + name + '"]');
      var n = parseInt(step.dataset.n || '3', 10);
      bar.style.width = (name === 'result' ? 100 : ((n - 1) / 3) * 100) + '%';
      count.textContent = name === 'result' ? 'Your match' : 'Question ' + n + ' of 3';
      back.hidden = history.length === 0;
      var h = step.querySelector('h2');
      if (h && push !== false) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      var top = q.getBoundingClientRect().top + window.scrollY - 120;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function result() {
      var key = state.skin === 'none' ? (state.cat === 'body' ? 'body-calm' : state.cat + '-none') : state.cat + '-' + state.scent;
      var bundleKey = state.skin === 'none' && state.cat !== 'body' ? BUNDLES.none : BUNDLES[state.cat];
      var pool = q.querySelector('.bl-quiz__pool');
      var main = pool.querySelector('[data-key="' + key + '"]');
      var bundle = pool.querySelector('[data-key="' + bundleKey + '"]');
      var slotA = q.querySelector('[data-slot="main"]');
      var slotB = q.querySelector('[data-slot="bundle"]');
      slotA.innerHTML = '';
      slotB.innerHTML = '';
      if (main) slotA.appendChild(main.cloneNode(true));
      if (bundle) slotB.appendChild(bundle.cloneNode(true));
      q.querySelector('[data-note="body-sensitive"]').hidden = !(state.cat === 'body' && state.skin === 'none');
      show('result');
    }

    q.addEventListener('click', function (e) {
      var a = e.target.closest('[data-answer]');
      if (a) {
        var step = a.closest('[data-step]');
        state[step.dataset.key] = a.dataset.answer;
        var next = a.dataset.next || step.dataset.next;
        if (next === 'scent') next = 'scent-' + state.cat;
        if (next === 'result') result(); else show(next);
        return;
      }
      if (e.target.closest('[data-quiz-back]')) {
        var prev = history.pop();
        if (prev) show(prev, false);
        back.hidden = history.length === 0;
        return;
      }
      if (e.target.closest('[data-quiz-restart]')) {
        state = {}; history = []; q.dataset.current = '';
        show('cat', false);
      }
    });
    show('cat', false);
  }

  /* ---------- Ingredient filter ---------- */
  function initIngredients(root) {
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ing-filter]');
      if (!chip) return;
      var line = chip.getAttribute('data-ing-filter');
      root.querySelectorAll('[data-ing-filter]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      root.querySelectorAll('[data-lines]').forEach(function (card) {
        card.hidden = line !== 'all' && card.getAttribute('data-lines').indexOf(line) === -1;
      });
    });
  }

  function init() {
    updateShip();
    watchEco();
    document.querySelectorAll('[data-bl-quiz]').forEach(initQuiz);
    document.querySelectorAll('[data-bl-ingredients]').forEach(initIngredients);
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bl-add]');
      if (btn && !btn.disabled) { e.preventDefault(); addToBag(btn); return; }
      var bb = e.target.closest('[data-boost-add]');
      if (bb && !bb.disabled) { e.preventDefault(); boostAdd(bb); }
    });
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, updateShip); } catch (e) {}
    }
    var notif = document.querySelector('cart-notification');
    if (notif) new MutationObserver(updateShip).observe(notif, { attributes: true, attributeFilter: ['class'] });
    var ci = document.querySelector('cart-items');
    if (ci) new MutationObserver(function () { if (!ci.querySelector('.bl-ship') || !ci.querySelector('.bl-boost')) updateShip(); }).observe(ci, { childList: true });
  }

  /* Start watching cart requests right away; wire the rest after the theme's deferred scripts (pubsub.js) have run. */
  watchCartRequests();
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
